import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';

/**
 * A Service/Repair search result returned by the AirportsAPI `~/service-repairs` endpoint. A service/repair
 * business is one carrying any `Maintenance::` tag, mirroring the iOS app's `tagPrefix: "Maintenance"`
 * classification. Mirrors {@link FboResult}'s `static parse` convention (minus fuel, which does not apply).
 */
/**
 * Maintenance categories (the 2nd segment of a `Maintenance::<Category>::...` tag), in display order. Used to
 * summarize what a shop covers on the results card.
 */
export const SERVICE_REPAIR_CATEGORY_ORDER = [
  'Airframe', 'Avionics', 'Powerplant', 'Propeller', 'Interior', 'Exterior', 'Rotor'
];

export class ServiceRepairResult extends BusinessFinderResult {

  /**
   * Thumbnail image for the results card (business logo or first photo). Null when it has no photo.
   */
  thumbnailPhotoPath: string;

  /**
   * Distinct maintenance categories this business covers (e.g. ["Airframe", "Avionics"]), derived from its
   * tags and shown on the results card. Ordered per {@link SERVICE_REPAIR_CATEGORY_ORDER}.
   */
  categories: string[];

  static parse(data: any): ServiceRepairResult {
    const tags: string[] = (data.tags || []).map(d => d);
    const present = new Set<string>();
    tags.forEach(t => {
      const parts = t.split('::');
      if (parts.length >= 2) {
        present.add(parts[1]);
      }
    });
    const categories = SERVICE_REPAIR_CATEGORY_ORDER.filter(c => present.has(c));
    return Object.assign(new ServiceRepairResult(), {
      businessId: data.businessId,
      name: data.name || null,
      city: data.city || null,
      stateProvince: data.stateProvince || null,
      latitude: isNumeric(data.latitude) ? +data.latitude : null,
      longitude: isNumeric(data.longitude) ? +data.longitude : null,
      location: (isNumeric(data.latitude) && isNumeric(data.longitude))
        ? parseLatLon(data.latitude, data.longitude) : null,
      phone1: data.phone1 || null,
      webAddress: data.webAddress || null,
      emailAddress: data.emailAddress || null,
      description: data.description || null,
      distance: isNumeric(data.distance) ? +data.distance : null,
      airportIdent: data.airportIdent || null,
      airportName: data.airportName || null,
      tags: tags,
      categories: categories,
      thumbnailPhotoPath: data.thumbnailPhotoPath || null
    });
  }
}
